import React from 'react';

export class Container extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        const p = this.props;
        return (
            <div 
                className   = { `marketkit-checkbox${ p.className ? ' ' + p.className : '' }${ p.isChecked ? ' checked' : '' }`}
                onClick     = { (e) => p.onClick(e) }
                { ...p.attrs }
            >
                { p.children }
            </div>
        )
    }
}

export default Container;